import ApiService from "../../services/ApiService";

const ReferralService = {
    requestList: async (paginationModel, sort, setRows, setRowCount, keyword) => {
        let param = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            keyword: keyword ? encodeURIComponent(keyword) : "",
        };

        const result = await ApiService.getData("/v1/referral/events", param);
        setRows(result.content || []);
        setRowCount(result.page?.totalElements ?? 0);
    },

    createEvent: async (name, startAt, endAt, requiredCount, rewardMonths) => {
        let param = {
            name: name,
            startAt: startAt,
            endAt: endAt,
            requiredCount: requiredCount,
            rewardMonths: rewardMonths,
        };

        const result = await ApiService.postData("/v1/referral/events", param);
        return result;
    },

    getEvent: async (eventId) => {
        const result = await ApiService.getData(`/v1/referral/events/${eventId}`);
        return result;
    },

    getStats: async (eventId) => {
        let param = {};
        if (eventId) {
            param.eventId = eventId;
        }

        const result = await ApiService.getData("/v1/referral/stats", param);
        return result;
    },

    listInviters: async (paginationModel, sort, setRows, setRowCount, eventId, keyword) => {
        let param = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            eventId: eventId || "",
            keyword: keyword ? encodeURIComponent(keyword) : "",
        };

        const result = await ApiService.getData("/v1/referral-inviter", param);
        setRows(result.content || []);
        setRowCount(result.page?.totalElements ?? 0);
    },

    getInvitesByInviterId: async (eventId, inviterId) => {
        const result = await ApiService.getData(`/v1/referral-inviter/${eventId}/${inviterId}/invites`);
        return result;
    },
};

export default ReferralService;

